import { Button, Flex, Grid, GridCol, Select, Text } from "@mantine/core";
import { useDebouncedState } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconBuilding,
  IconBuildingStore,
  IconSearch,
  IconUserCircle,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useMemo, useState } from "react";
import {
  repositoryPos,
  styleTableMantine,
} from "../../../../_base/_const/_constVar";
import { AvatarUtils } from "../../../../common/ColorByName/AvatarUtils";
import InputSearch from "../../../../common/InputSearch/InputSearch";
import { _localization } from "../../../../config/location";
import { ComboboxItem } from "../../../../model/ComboboxItem";
import { EmployeeModel } from "../../../../model/Employee";
import { MessageResponse } from "../../../../model/MessageResponse";
import {
  getBranchSelect,
  getTblDepartmentSelect,
  getTblRoleSelect,
} from "../../../../service/getSelectApi";
import { SelectListItemBase } from "../../../../_base/model/_base/SelectListItemBase";

const ListEmployeeFund = ({
  handleChooseNhanVien,
  openFormNhanVien,
}: {
  handleChooseNhanVien: Function;
  openFormNhanVien?: any;
}) => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<EmployeeModel[]>([]);
  const [isError, setIsError] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);

  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  //
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  //count
  const [dataDepartment, setDataDepartment] = useState<ComboboxItem[]>([]);
  const [dataEmployee, setDataEmployee] = useState<ComboboxItem[]>([]);
  const [dataRole, setDataRole] = useState<ComboboxItem[]>([]);
  const sizeGrid = { base: 6, sm: 4, md: 3, lg: 3, xl: 2 };
  const [isFirstFetch, setIsFirstFetch] = useState(true);
  const [dataBranch, setDataBranch] = useState<SelectListItemBase[]>([]);
  const [search, setSearch] = useDebouncedState(
    {
      roleId: "",
      departmentId: "",
      managerId: "",
      branchId: "",
      keySearch: "",
    },
    300
  );

  const handleChangeSearchValue = (value: string, key: string) => {
    setSearch((prevData) => ({ ...prevData, [key]: value }));
  };

  const fetchDataRole = async () => {
    const response = await getTblRoleSelect();
    const mappedData = response
      .filter(
        (item) => item.value != null && item.text != null && item.value !== "-1"
      )
      .map((item) => ({
        value: item.value,
        label: `${item.text}`,
      }));
    setDataRole(mappedData);
  };

  const fetchDataBranch = async () => {
    const response = await repositoryPos.get<
      MessageResponse<SelectListItemBase[]>
    >("/api/v1/TblDmInventory/get-select-branch?auth=false");

    if (response && response.success) {
      let result = response.data;
      setDataBranch(result);
    }
  };

  const fetchDataDepartment = async () => {
    const getDataDepartment = await getTblDepartmentSelect();

    const mappedData = getDataDepartment
      .filter(
        (item) => item.value != null && item.text != null && item.value !== "-1"
      )
      .map((item) => ({
        value: item.value,
        label: `${item.text}`,
      }));
    setDataDepartment(mappedData);
  };

  const fetchData = async () => {
    //  setIsLoading(true);
    // setIsRefetching(true);
    let url = `&Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
      pagination.pageSize
    }`;

    if (search.roleId) {
      url += `&RoleId=${search.roleId}`;
    }
    if (search.departmentId) {
      url += `&DepartmentId=${search.departmentId}`;
    }
    if (search.managerId) {
      url += `&ManagerId=${search.managerId}`;
    }
    if (search.branchId) {
      url += `&BranchId=${search.branchId}`;
    }

    if (search.keySearch) {
      url += `&KeySearch=${search.keySearch}`;
    }
    try {
      const response = await repositoryPos.get<
        MessageResponse<EmployeeModel[]>
      >(`/api/v1/TblDmEmployee/get-list?Active=false${url}`);
      if (response && response.success) {
        setData(response.data ?? []);
        setRowCount(response.totalCount);
        setSelectIds([]);
        table.resetRowSelection();
      }
    } catch (error) {
      setIsError(true);
      console.error(error);
      return;
    }
  };

  function formatDate(isoDateString: string): string {
    const date: Date = new Date(isoDateString);
    // Cộng thêm 7 tiếng
    date.setHours(date.getHours() + 7);
    // Lấy các thành phần ngày giờ sau khi cộng thêm số giờ
    const hours: string = date.getHours().toString().padStart(2, "0");
    const minutes: string = date.getMinutes().toString().padStart(2, "0");
    const seconds: string = date.getSeconds().toString().padStart(2, "0");
    const day: string = date.getDate().toString().padStart(2, "0");
    const month: string = (date.getMonth() + 1).toString().padStart(2, "0"); // Tháng bắt đầu từ 0
    const year: number = date.getFullYear();

    // Định dạng thành chuỗi "giờ:phút:giây ngày-tháng-năm"
    return `${day}-${month}-${year}`;
  }

  const columns = React.useMemo<MRT_ColumnDef<EmployeeModel>[]>(
    () => [
      {
        accessorKey: "STT",
        header: "STT",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        Cell: ({ row }) => <Text size="12.5px">{row.index + 1}</Text>,
        size: 50,
      },
      {
        accessorKey: "code",
        header: "Mã nhân viên",
      },
      {
        accessorKey: "fullname",
        header: "Tên nhân viên",
        size: 250,
      },
      {
        accessorKey: "email",
        header: "Email",
        size: 250,
      },
      {
        accessorKey: "departmentName",
        header: "Phòng ban",
        size: 250,
      },
      {
        accessorKey: "roleName",
        header: "Chức vụ",
      },
    ],
    []
  );

  useEffect(() => {
    fetchDataBranch();
  }, []);

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);

  useEffect(() => {
    if (openFormNhanVien?.original?.branchesFund && dataBranch.length > 0) {
      const check = dataBranch?.find(
        (item) =>
          String(item.att2) === String(openFormNhanVien.original.branchesFund)
      );
      handleChangeSearchValue(check?.value || "", "branchId");
    }
  }, [openFormNhanVien, dataBranch]);

  useEffect(() => {
    if (search.branchId && isFirstFetch) {
      fetchData();
      setIsFirstFetch(false);
    }
  }, [search.branchId]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (300 + headerHeight));
    };
    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);

  useEffect(() => {
    fetchData();
  }, [pagination.pageIndex, openFormNhanVien, pagination.pageSize]);

  const table = useMantineReactTable({
    columns,
    data,
    positionToolbarAlertBanner: "bottom",
    enablePagination: true,
    enableRowVirtualization: true,
    enableToolbarInternalActions: false,
    enableTopToolbar: false,
    enableColumnResizing: true,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    getRowId: (row) => row.id?.toString(),
    initialState: {
      columnPinning: {
        left: ["STT"],
      },
      showColumnFilters: false,
      columnVisibility: { id: false },
      density: "xs",
      pagination: {
        pageIndex: 0,
        pageSize: 50,
      },
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    manualPagination: true,
    rowCount,
    // onColumnFiltersChange: setColumnFilters,
    // onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    // onSortingChange: setSorting,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    state: {
      pagination,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["20", "50", "75"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    mantineTableBodyRowProps: ({ row }) => ({
      onDoubleClick: () => {
        handleChooseNhanVien(row.original, openFormNhanVien);
        modals.closeAll();
      },
      sx: {
        cursor: "pointer",
      },
    }),
  });

  return (
    <>
      <div ref={headerRef}>
        <Grid mt={"10px"}>
          <GridCol span={sizeGrid}>
            <InputSearch
              width="100%"
              placeholder="Từ khoá"
              onSearch={fetchData}
              onChange={(value) => {
                handleChangeSearchValue(value, "keySearch");
              }}
            />
          </GridCol>
          <GridCol span={sizeGrid}>
            <Select
              searchable
              clearable
              placeholder="Chọn chi nhánh"
              comboboxProps={{
                transitionProps: { transition: "pop", duration: 200 },
              }}
              value={
                dataBranch?.find(
                  (item: SelectListItemBase) => item.value === search.branchId
                )?.value || null
              }
              leftSection={<IconBuildingStore color="#15aabf" />}
              nothingFoundMessage={"Loading..."}
              data={dataBranch
                ?.sort((a: any, b: any) => a.att2 - b.att2)
                .map((ele, index) => {
                  return {
                    label: ele.text,
                    value: ele.value,
                  };
                })
                .slice(1)}
              onChange={(value) => {
                handleChangeSearchValue(value || "", "branchId");
              }}
            />
          </GridCol>
          <GridCol span={sizeGrid}>
            <Select
              searchable
              clearable
              placeholder="Chọn phòng ban"
              comboboxProps={{
                transitionProps: { transition: "pop", duration: 200 },
              }}
              leftSection={<IconBuilding color="#15aabf" />}
              nothingFoundMessage={"Loading..."}
              data={dataDepartment}
              onChange={(value) => {
                handleChangeSearchValue(value || "", "departmentId");
              }}
              onClick={() => {
                if (dataDepartment.length === 0) {
                  fetchDataDepartment();
                }
              }}
            />
          </GridCol>
          <GridCol span={sizeGrid}>
            <Select
              placeholder={"Chọn chức vụ"}
              searchable
              clearable
              data={dataRole}
              leftSection={<IconUserCircle color="#15aabf" />}
              comboboxProps={{
                transitionProps: { transition: "pop", duration: 200 },
              }}
              nothingFoundMessage={"Loading..."}
              onChange={(value) =>
                handleChangeSearchValue(value || "", "roleId")
              }
              onClick={() => {
                if (dataRole.length === 0) {
                  fetchDataRole();
                }
              }}
            />
          </GridCol>
          <GridCol span={{ base: 4, sm: 4, md: 1.5, lg: 1.5 }}>
            <Button
              leftSection={<IconSearch size={14} />}
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchData();
              }}
            >
              Tìm kiếm
            </Button>
          </GridCol>
        </Grid>
      </div>
      <div>
        <MantineReactTable table={table} />
      </div>
    </>
  );
};

export default ListEmployeeFund;
